<div data-at-invitation-status class="flex-[18%] max-w-[18%]">{{ statusName }}</div>
<div data-at-invitation-edited class="flex-[22%] max-w-[22%]">
  {{ invitation.editedAt | date: 'shortDate' }}
</div>
<div data-at-inviter class="inviter-cell flex-[30%] max-w-[30%]">
  <a
    class="inviter-name"
    target="_blank"
    gtm="onGoToPage"
    gtmAction="Inviter details"
    gtmCategory="gateway"
    *ngIf="invitation.inviterAccount as inviterId"
    [routerLink]="['/users', inviterId]"
    matTooltip="{{ inviterName }}"
    >{{ inviterName }}</a
  >
  <div class="company-name" matTooltip="{{ inviterCompanyName }}">{{ inviterCompanyName }}</div>
</div>
<div *ngIf="inviteeName || inviteeCompanyName" data-at-invitee class="flex-[30%] max-w-[30%]">
  <a
    class="invitee-name"
    target="_blank"
    gtm="onGoToPage"
    gtmAction="Invitee details"
    gtmCategory="gateway"
    *ngIf="invitation.inviteeAccount as inviteeId; else customerNumber"
    [routerLink]="['/users', inviteeId]"
    matTooltip="{{ inviteeName }}"
    >{{ inviteeName }}</a
  >
  <ng-template #customerNumber>
    <a class="invitee-name" matTooltip="{{ invitation.customerNumber }}">{{
      invitation.customerNumber
    }}</a>
  </ng-template>
  <div class="company-name" matTooltip="{{ inviteeCompanyName }}">{{ inviteeCompanyName }}</div>
</div>
<div
  *ngIf="!inviteeName && !inviteeCompanyName && invitation.status === 'Pending'"
  data-at-invitee
  class="flex-[30%] max-w-[30%]"
>
  <div class="email" matTooltip="{{ inviteeEmail }}">{{ inviteeEmail }}</div>
  <div
    class="no-account-info"
    matTooltip="{{ '+INSTALLATIONS.INSTALLATION.IVITATION_LIST.NO_ACCOUNT_INFO' | translate }}"
  >
    {{ '+INSTALLATIONS.INSTALLATION.IVITATION_LIST.NO_ACCOUNT_INFO' | translate }}
  </div>
</div>
